import React, { useState, useEffect, Component } from "react";
import { Modal, Spinner } from 'react-bootstrap'
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faCircle, faCheckCircle, faPlus, faTrash, faEye, faCopy, faSearch, faKey } from '@fortawesome/free-solid-svg-icons';
import { getVaultItems, createVaultItem, deleteVaultItem, updateVaultItem, revealVaultItem, updateSelectedVault } from '../../api/backend';
import { Application } from '../../core/app';
import { escapeHtml } from '../../utils/sanitize';
import VaultDetail from "./VaultDetail";
import { Navigate } from "react-router-dom";
import AuthContext from '../../AuthContext';
import './Vault.css';


class Vault extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.hasRequestedItems = false;
  }

  state = {
      items: [],
      vaults: [],
      name: '',
      inputValue: '',
      inputDetailValue: '',
      showAddRecordForm: false,
      showDetailModal: false,
      showGenModal: false, 
      genLength: 16,
      genComplexity: 3,
      genPreviewPassword: '',
      showDeleteModal: false,
      itemToDelete: null,
      totalItemCount: 0,
      vaultItemName: '',
      vaultItemDetails: '',
      vaultItemValue: '',
      vaultItemTotpEnabled: false,
      searchValue: '',
      isLoading: false,
      selectedVault: Application.getSelectedVault() || '0',
      selectedItemId: null
  }
  _revealingItemId = null;

  componentDidMount() {
      this.loadItemsIfReady();
  }

    componentWillUnmount() {
    }

    loadItemsIfReady = () => {
      if (!this.props.user || this.hasRequestedItems) {
        return;
      }

      this.hasRequestedItems = true;
      this.setState({ isLoading: true });
      this.getItems();
    }


  getItems = () => {
      getVaultItems().then(res => {
          const items = res.data.items;
          const vaults = res.data.vaults
          this.setState({ items, vaults, isLoading: false });
      }).catch(() => {
          this.setState({ isLoading: false });
      });
  }

  setItems = (newItems) => {
      this.setState({ newItems });
  }

  setName = (value) => {
    this.setState({ name: value });
}

  setInputValue = (value) => {
      this.setState({ inputValue: value });
  }

  setInputDetailValue = (value) => {
    this.setState({ inputDetailValue: value });
}

  setTotalItemCount = (value) => {
      this.setState({ totalItemCount: value });
  }

  handleClose = () => {
    this.setState({
      showDetailModal: false,
      vaultItemName: '',
      vaultItemValue: '',
      vaultItemDetails: '',
      vaultItemTotpEnabled: false
    });
  }
    
  handleGenClick = () => {
    this.setState(
      { showGenModal: true },
      () => this.refreshGenPreview()
    );
  }

  // HINT: each "item" in our list names a name,
  // a boolean to tell if its been completed, and a quantity


  handleAddButtonClick = () => {

      this.setState({ isLoading: true });

      const newItem = {
          name: this.state.name,
          value: this.state.inputValue,
          details: this.state.inputDetailValue
      };

      createVaultItem(newItem).then(res => {
          this.getItems();
      }).catch(() => {
          this.setState({ isLoading: false });
      });

      const newItems = [...this.state.items, newItem];

      this.setItems(newItems);

      this.setName('');
      this.setInputDetailValue('');
      this.setInputValue('');
      this.setState({ showAddRecordForm: false });
  };

  handleAddRecordOpen = () => {
    this.setName('');
    this.setInputDetailValue('');
    this.setInputValue('');
    this.setState({ showAddRecordForm: true });
  }

  handleAddRecordCancel = () => {
    this.setName('');
    this.setInputDetailValue('');
    this.setInputValue('');
    this.setState({ showAddRecordForm: false });
  }

  handleItemDelete = (item) => {
      this.setState({ showDeleteModal: true, itemToDelete: item });
  };

  confirmDelete = () => {
      if (this.state.itemToDelete) {
          this.setState({ isLoading: true, showDeleteModal: false });
          deleteVaultItem(this.state.itemToDelete.id).then(res => {
              this.getItems();
          }).catch(() => {
              this.setState({ isLoading: false });
          });
          this.setState({ itemToDelete: null });
      }
  };

  cancelDelete = () => {
      this.setState({ showDeleteModal: false, itemToDelete: null });
  };

  revealVaultItem = (vaultItemId) => {
    if (this._revealingItemId === vaultItemId) return;
    this._revealingItemId = vaultItemId;

    this.setState({ 
      vaultItemValue: '',
      vaultItemDetails: '',
      vaultItemTotpEnabled: false,
      isLoading: true
    });

    revealVaultItem(vaultItemId).then(res => {
      if (res.status = 200) {
        this.setState({ 
          vaultItemName: res.data.name,
          vaultItemValue: res.data.value,
          vaultItemDetails: res.data.details,
          vaultItemTotpEnabled: res.data.totp_enabled || false,
          isLoading: false
        });
      }
    }).catch(() => {
      this.setState({ isLoading: false });
    }).finally(() => {
      this._revealingItemId = null;
    });
  };

  handleVaultDetailInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState({
      [name]: value
    });
  }

  updateVaultItem = (vaultItemId, event) => {
    this.setState({ isLoading: true });
    let data = {
      id: vaultItemId,
      name: event.target.vaultItemName.value,
      value: event.target.vaultItemValue.value,
      details: event.target.vaultItemDetails.value,
      vault_id: event.target.vaultItemVaultId ? event.target.vaultItemVaultId.value : null
    };

    updateVaultItem(data).then(res => {
        this.getItems();
    }).catch(() => {
        this.setState({ isLoading: false });
    });
  }

  selectVault = (vault) => {
    this.setState({ isLoading: true, selectedVault: vault.value });
    const vaultValue = vault.value;
    Application.setSelectedVault(vaultValue === '0' ? null : vaultValue);
    updateSelectedVault(vaultValue).then(res => {
      this.getItems();
    }).catch(() => {
      this.setState({ isLoading: false });
    });
  }

  // Simple password generator
  randomInt = (maxExclusive) => {
    if (maxExclusive <= 0) return 0;
    // Prefer crypto randomness when available.
    if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
      const array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      return array[0] % maxExclusive;
    }
    return Math.floor(Math.random() * maxExclusive);
  }

  generatePassword = (length = 16, complexity = 3) => {
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';
    const symbols = '!@#$%^&*()';

    // Complexity levels:
    // 1: lowercase
    // 2: lowercase + uppercase
    // 3: lowercase + uppercase + digits
    // 4: lowercase + uppercase + digits + symbols
    const groups = [lowercase];
    if (complexity >= 2) groups.push(uppercase);
    if (complexity >= 3) groups.push(digits);
    if (complexity >= 4) groups.push(symbols);

    const allChars = groups.join('');
    if (!allChars.length) return '';

    const finalLength = Math.max(4, Math.min(64, Number(length) || 16));

    const chars = [];

    // Ensure each enabled group is represented when possible.
    if (finalLength >= groups.length) {
      for (const group of groups) {
        chars.push(group.charAt(this.randomInt(group.length)));
      }
    }

    while (chars.length < finalLength) {
      chars.push(allChars.charAt(this.randomInt(allChars.length)));
    }

    // Shuffle so required chars aren't always at the front.
    for (let i = chars.length - 1; i > 0; i--) {
      const j = this.randomInt(i + 1);
      const tmp = chars[i];
      chars[i] = chars[j];
      chars[j] = tmp;
    }

    return chars.join('');
  }

  handlePasswordGenerate = () => {
    const password = this.state.genPreviewPassword || this.generatePassword(this.state.genLength, this.state.genComplexity);
    this.setState({ inputValue: password, showGenModal: false });
  }

  refreshGenPreview = () => {
    const password = this.generatePassword(this.state.genLength, this.state.genComplexity);
    this.setState({ genPreviewPassword: password });
  }

  setGenLength = (_event, value) => {
    this.setState({ genLength: value }, this.refreshGenPreview);
  }

  setGenComplexity = (_event, value) => {
    this.setState({ genComplexity: value }, this.refreshGenPreview);
  }

  handleGenModalClose = () => {
    this.setState({ showGenModal: false, genPreviewPassword: '' });
  }

  setSearchValue = (value) => {
    this.setState({ searchValue: value });
  }

  openDetail = (itemId) => {
    if (this._revealingItemId === itemId) return;
    this.setState({ selectedItemId: itemId });
    this.revealVaultItem(itemId);
  }

  closeDetail = () => {
    this._revealingItemId = null;
    this.setState({ selectedItemId: null });
  }


  render() {
    const normalizedSearch = this.state.searchValue.trim().toLowerCase();
    const visibleItems = normalizedSearch
      ? this.state.items.filter((item) => (item.name || '').toLowerCase().includes(normalizedSearch))
      : this.state.items;

    return (
      <div>
        {this.state.isLoading && (
          <div className='vault-loading-overlay'>
            <div className='vault-loading-spinner'>
              <CircularProgress size={40} />
            </div>
          </div>
        )}
        <Dialog
          open={this.state.showGenModal}
          onClose={this.handleGenModalClose}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            sx: { width: 'calc(100vw - 32px)', maxWidth: 480 }
          }}
        >
          <DialogTitle>Password Generator</DialogTitle>
          <DialogContent sx={{ overflowX: 'hidden' }}>
            <div style={{ width: '100%', maxWidth: '100%', paddingTop: '8px' }}>
              <Typography variant="body2" style={{ marginBottom: '6px' }}>
                Preview
              </Typography>
              <div className='vault-gen-preview'>
                <button
                  type="button"
                  className='vault-detail-copy-btn'
                  onClick={() => navigator.clipboard.writeText(this.state.genPreviewPassword)}
                  title="Copy password"
                >
                  <FontAwesomeIcon icon={faCopy} />
                </button>
                <div className='vault-gen-preview-text'>
                  {this.state.genPreviewPassword}
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                <button type="button" className='vault-totp-action-btn vault-totp-action-btn--refresh' onClick={this.refreshGenPreview}>
                  <FontAwesomeIcon icon={faKey} /> Regenerate
                </button>
              </div>

              <div className='vault-gen-slider-label'>
                <Typography variant="body2">Length</Typography>
                <Typography variant="body2" style={{ color: '#64b5f6' }}>{this.state.genLength}</Typography>
              </div>
              <Slider
                value={this.state.genLength}
                onChange={this.setGenLength}
                min={8}
                max={64}
                step={1}
                valueLabelDisplay="auto"
                sx={{
                  '& .MuiSlider-thumb': { backgroundColor: '#64b5f6' },
                  '& .MuiSlider-track': { backgroundColor: '#64b5f6' },
                  '& .MuiSlider-rail': { backgroundColor: 'rgba(255,255,255,0.1)' }
                }}
              />

              <div className='vault-gen-slider-label' style={{ marginTop: '14px' }}>
                <Typography variant="body2">Complexity</Typography>
              </div>
              <Slider
                value={this.state.genComplexity}
                onChange={this.setGenComplexity}
                min={1}
                max={4}
                step={1}
                marks={[
                  { value: 1, label: 'Low' },
                  { value: 2, label: 'Med' },
                  { value: 3, label: 'High' },
                  { value: 4, label: 'Max' },
                ]}
                sx={{
                  '& .MuiSlider-thumb': { backgroundColor: '#64b5f6' },
                  '& .MuiSlider-track': { backgroundColor: '#64b5f6' },
                  '& .MuiSlider-rail': { backgroundColor: 'rgba(255,255,255,0.1)' }
                }}
              />

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '18px' }}>
                <button className='vault-cancel-btn' onClick={this.handleGenModalClose}>Cancel</button>
                <button className='vault-add-btn' onClick={this.handlePasswordGenerate}>Use Password</button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog open={this.state.showDeleteModal} onClose={this.cancelDelete}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <p>Are you sure you want to delete this item?</p>
            <p><strong>{this.state.itemToDelete ? escapeHtml(this.state.itemToDelete.name) : ''}</strong></p>
          </DialogContent>
          <DialogActions>
            <button className="btn btn-secondary" onClick={this.cancelDelete}>Cancel</button>
            <button className="btn btn-danger" onClick={this.confirmDelete}>Delete</button>
          </DialogActions>
        </Dialog>

        {/* Main Vault Page */}
        <div className='app-background'>
        <div className='vault-page'>
          {/* Header: Vault selector + Search + Add */}
          <div className='vault-header'>
            <div className='vault-header-left'>
              <div className='vault-select-wrapper'>
                <select
                  className='vault-select'
                  value={this.state.selectedVault}
                  onChange={(event) => this.selectVault(event.target)}
                >
                  <option value='0'>All Vaults</option>
                  {this.state.vaults.map((item, index) => (
                    <option key={index} value={item.id}>
                      {escapeHtml(item.name)}
                    </option>
                  ))}
                </select>
              </div>
              <div className='vault-search-wrapper'>
                <FontAwesomeIcon icon={faSearch} className='vault-search-icon' />
                <input
                  className='vault-search'
                  value={this.state.searchValue}
                  onChange={(event) => this.setSearchValue(event.target.value)}
                  placeholder='Search records...'
                />
              </div>
            </div>
            <div className='vault-header-right'>
              {!this.state.showAddRecordForm ? (
                <button className='vault-add-btn' onClick={this.handleAddRecordOpen}>
                  <FontAwesomeIcon icon={faPlus} />
                  <span>New Record</span>
                </button>
              ) : null}
            </div>
          </div>

          {/* Add Form Panel */}
          {this.state.showAddRecordForm && (
            <div className='vault-add-form'>
              <div className='field-group'>
                <label className='field-label' htmlFor="vault-item-name">Name</label>
                <div className='field-input-wrapper'>
                  <input
                    id="vault-item-name"
                    value={this.state.name}
                    onChange={(event) => this.setName(event.target.value)}
                    className='field-input'
                    placeholder='e.g. Gmail, Netflix, Bank...'
                    autoFocus
                  />
                </div>
              </div>
              <div className='field-group'>
                <label className='field-label' htmlFor="vault-item-details">Details</label>
                <div className='field-input-wrapper'>
                  <input
                    id="vault-item-details"
                    value={this.state.inputDetailValue}
                    onChange={(event) => this.setInputDetailValue(event.target.value)}
                    className='field-input'
                    placeholder='Username, email, URL...'
                  />
                </div>
              </div>
              <div className='field-group'>
                <label className='field-label' htmlFor="vault-item-value">Value</label>
                <div className='field-input-wrapper'>
                  <input
                    id="vault-item-value"
                    value={this.state.inputValue}
                    onChange={(event) => this.setInputValue(event.target.value)}
                    className='field-input'
                    placeholder='Password or secret...'
                  />
                  <button
                    type="button"
                    className='vault-gen-btn'
                    onClick={() => this.handleGenClick()}
                  >
                    <FontAwesomeIcon icon={faKey} /> Gen
                  </button>
                </div>
              </div>
              <div className='vault-form-actions'>
                <button className='vault-add-btn' onClick={() => this.handleAddButtonClick()}>
                  <FontAwesomeIcon icon={faPlus} />
                  <span>Add Record</span>
                </button>
                <button className='vault-cancel-btn' onClick={this.handleAddRecordCancel}>Cancel</button>
              </div>
            </div>
          )}

          {/* Item List */}
          <div className='vault-list'>
            <div className='vault-list-header'>
              <span className='vault-list-count'>
                {visibleItems.length} {visibleItems.length === 1 ? 'record' : 'records'}
              </span>
            </div>

            {visibleItems.length === 0 ? (
              <div className='vault-empty'>
                <FontAwesomeIcon icon={faKey} className='vault-empty-icon' />
                <div className='vault-empty-title'>
                  {this.state.searchValue ? 'No matching records' : 'No records yet'}
                </div>
                <div className='vault-empty-text'>
                  {this.state.searchValue
                    ? 'Try a different search term.'
                    : 'Tap "New Record" to add your first password.'}
                </div>
              </div>
            ) : (
              visibleItems.map((item, index) => {
                const showVaultTag = this.state.selectedVault === '0' && item.vault_id;
                const vaultName = showVaultTag
                  ? (this.state.vaults?.find(v => v.id === item.vault_id)?.name || '')
                  : '';

                return (
                  <div
                    key={item.id || index}
                    className='vault-item'
                    onClick={() => this.openDetail(item.id)}
                  >
                    <div className={`vault-item-icon ${item.totp_enabled ? 'totp' : ''}`}>
                      <FontAwesomeIcon icon={item.totp_enabled ? faKey : faEye} />
                    </div>
                    <div className='vault-item-content'>
                      <div className='vault-item-name'>{escapeHtml(item.name)}</div>
                      {item.details && (
                        <div className='vault-item-detail'>{escapeHtml(item.details)}</div>
                      )}
                    </div>
                    <div className='vault-item-badges'>
                      {item.totp_enabled ? (
                        <span className='vault-badge vault-badge--totp'>2FA</span>
                      ) : null}
                      {showVaultTag && vaultName && (
                        <span className='vault-badge vault-badge--vault'>{escapeHtml(vaultName)}</span>
                      )}
                    </div>
                    <div className='vault-item-actions'>
                      <button
                        className='vault-action-btn vault-action-btn--delete'
                        onClick={(e) => {
                          e.stopPropagation();
                          this.handleItemDelete(item);
                        }}
                        title="Delete"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
        </div>

        {/* Detail Modal - rendered outside the main layout */}
        {this.state.items.map((item, index) => (
          <VaultDetail
            key={item.id || index}
            vaultItemName={item.name}
            vaultItemDetails={this.state.vaultItemDetails}
            vaultItemValue={this.state.vaultItemValue}
            vaultItemId={item.id}
            vaultItemVaultId={item.vault_id}
            vaultItemTotpEnabled={this.state.vaultItemTotpEnabled}
            vaults={this.state.vaults}
            selectedVault={this.state.selectedVault}
            revealVaultItem={this.revealVaultItem}
            updateVaultItem={this.updateVaultItem}
            hideTrigger={true}
            open={this.state.selectedItemId === item.id}
            onOpenChange={(isOpen, id) => {
              if (!isOpen) {
                this.closeDetail();
              } else {
                this.openDetail(id);
              }
            }}
          />
        ))}
      </div>
    );
  }
}

export default Vault;